/* tutor-1 (C): EL ARRANQUE (conversacion vacia): la chispa grande con halo, el saludo con el nombre de pila (el
   invitado, sin nombre), "Pregunta de cualquier materia..." y las cuatro tarjetas 2 x 2 de 64 de alto: explicar y
   resolver ponen su texto en el cuadro y lo mandan; documentos abre el panel de elegir; la cuarta es "Repasa mi tema
   mas flojo" con el tema si hay analiticas o "Revisa mi respuesta", que abre el selector de fotos.

   tutor-3 (B.4, P9, #686): la PRIMERA tarjeta ya no es "Explicame un tema": es "Arma mi plan de repaso para esta
   semana" (`chip.analytics_plan`) con el renglon "Tus analiticas" (`sources.analytics`), textos que ya existian;
   al tocarla manda ese texto. Las llaves `starter.explain` y `starter.explain_sub` se quedan sin uso en los locales.

   ARCHIVO EN ASCII A PROPOSITO. */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calculator, CalendarDays, Camera, FileText, Target } from 'lucide-react';
import Chispa from './Chispa';

function Tarjeta({ icono: Icono, titulo, sub, alTocar, testid }) {
  return (
    <button type="button" onClick={alTocar} data-testid={testid}
      className="grid grid-cols-[32px_1fr] gap-3 items-center text-left rounded-[14px] bg-[#141414] border border-[#222222] hover:border-[#2E2E2E] hover:bg-[#171717] p-3.5 min-h-[64px]">
      <span aria-hidden="true" className="w-8 h-8 rounded-[10px] bg-[#241710] border border-[#3A2414] text-[#F7A06A] flex items-center justify-center">
        <Icono className="w-4 h-4" />
      </span>
      <span className="min-w-0">
        <span className="block text-[14px] font-semibold text-[#F4F4F3]">{titulo}</span>
        <span className="block text-[12.5px] text-[#9A9A9A] mt-0.5 truncate">{sub}</span>
      </span>
    </button>
  );
}

export function nombreDePila(user) {
  return String((user && user.name) || '').trim().split(/\s+/)[0] || '';
}

/* tutor-2 (D.3): el arranque de la conversacion "Mis analiticas": el saludo, el renglon y los tres chips de sugerencia
   (tocar uno lo manda), en lugar de las cuatro tarjetas. */
export const CHIPS_DE_ANALITICAS = ['tutor.chip.analytics_worst', 'tutor.chip.analytics_plan', 'tutor.chip.analytics_ready'];

export default function Arranque({ user, temaFlojo, alPreguntar, alElegirDocumentos, alElegirFotos, analiticas = false }) {
  const { t } = useTranslation('study');
  const nombre = user && !user.is_guest ? nombreDePila(user) : '';
  const plan = t('tutor.chip.analytics_plan');
  const resolver = t('tutor.starter.solve');
  return (
    <div className="flex-1 min-h-0 overflow-y-auto" data-testid="tutor-arranque-scroll">
    <div className="min-h-full flex flex-col justify-center items-center gap-[22px] py-5" data-testid="tutor-arranque"
      data-variante={analiticas ? 'analiticas' : 'tarjetas'}>
      <Chispa tam={48} halo />
      <h2 className="m-0 font-['Space_Grotesk'] font-semibold text-[26px] tracking-[-.03em] text-center text-[#F4F4F3]" style={{ textWrap: 'balance' }}>
        {nombre ? t('tutor.empty.greeting', { name: nombre }) : t('tutor.empty.greeting_guest')}
      </h2>
      <p className="-mt-3 mb-0 text-[14px] text-center text-[#9A9A9A]">{t('tutor.empty.sub')}</p>
      {analiticas ? (
        <div className="flex flex-wrap justify-center gap-2 max-w-[640px]" data-testid="tutor-arranque-analiticas">
          {CHIPS_DE_ANALITICAS.map((k) => (
            <button key={k} type="button" onClick={() => alPreguntar(t(k), true)}
              className="min-h-[44px] md:min-h-[36px] px-3.5 rounded-full border border-[#2C2C2C] bg-[#1B1B1B] text-[13.5px] text-[#C8C8C8] hover:border-[#3a3a3a] hover:text-[#F4F4F3]"
              data-testid="tutor-chip-arranque-analiticas">
              {t(k)}
            </button>
          ))}
        </div>
      ) : (
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 w-full max-w-[640px]">
        <Tarjeta icono={CalendarDays} titulo={plan} sub={t('tutor.sources.analytics')} testid="tutor-arranque-plan"
          alTocar={() => alPreguntar(plan, true)} />
        <Tarjeta icono={Calculator} titulo={resolver} sub={t('tutor.starter.solve_sub')} testid="tutor-arranque-resolver"
          alTocar={() => alPreguntar(resolver, true)} />
        <Tarjeta icono={FileText} titulo={t('tutor.starter.docs')} sub={t('tutor.starter.docs_sub')} testid="tutor-arranque-documentos"
          alTocar={alElegirDocumentos} />
        {temaFlojo && temaFlojo.nombre ? (
          <Tarjeta icono={Target} titulo={t('tutor.starter.weak')} sub={t('tutor.starter.weak_sub', { topic: temaFlojo.nombre })}
            testid="tutor-arranque-flojo"
            alTocar={() => alPreguntar(`${t('tutor.starter.weak')}: ${temaFlojo.nombre}`, true, temaFlojo.documento_id)} />
        ) : (
          <Tarjeta icono={Camera} titulo={t('tutor.starter.check')} sub={t('tutor.starter.check_sub')} testid="tutor-arranque-revisar"
            alTocar={alElegirFotos} />
        )}
      </div>
      )}
    </div>
    </div>
  );
}
